import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ScrollToTop() {
  const { ref, isVisible } = useScrollReveal(0);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div ref={ref}>
      <button
        onClick={scrollTop}
        className={`fixed bottom-8 right-8 z-40 w-11 h-11 rounded-xl bg-foreground-900/80 backdrop-blur-sm text-background-50 flex items-center justify-center hover:bg-primary-500 hover:scale-110 active:scale-95 transition-all duration-300 cursor-pointer shadow-lg ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        aria-label="回到顶部"
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </div>
  );
}